import { render, staticRenderFns } from "./writeOffPersonal.vue?vue&type=template&id=4cb32b3c&scoped=true"
import script from "./writeOffPersonal.vue?vue&type=script&lang=js"
export * from "./writeOffPersonal.vue?vue&type=script&lang=js"
import style0 from "./writeOffPersonal.vue?vue&type=style&index=0&id=4cb32b3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb32b3c",
  null
  
)

export default component.exports